(function () {
  if (window.PrintyhouseKonvaMockups) return;

  function clamp(value, min, max) {
    return Math.min(max, Math.max(min, value));
  }

  function parseSizeId(sizeId) {
    var match = String(sizeId || '').trim().match(/(\d+)\s*x\s*(\d+)/i);
    if (!match) return null;
    return {
      width: Number(match[1]),
      height: Number(match[2]),
    };
  }

  function getAspectRatioValue(aspectRatioKey, sizeId) {
    var parsed = parseSizeId(sizeId);
    if (parsed && parsed.width > 0 && parsed.height > 0) return parsed.width / parsed.height;

    var key = String(aspectRatioKey || '').toLowerCase();
    if (key === 'landscape') return 3 / 2;
    if (key === 'portrait') return 2 / 3;
    return 1;
  }

  function getSizeScale(sizeId) {
    var parsed = parseSizeId(sizeId);
    if (!parsed) return 0.84;

    var longestSide = Math.max(parsed.width, parsed.height);
    return clamp(0.74 + ((longestSide - 6) / 18) * 0.16, 0.78, 0.9);
  }

  function getSceneWallSize(scene) {
    if (scene && scene.wallSizeInches) return scene.wallSizeInches;
    return { width: 76, height: 50 };
  }

  function getSceneArtScale(scene) {
    var scale = Number(scene && scene.artScale) || 1;
    return clamp(scale, 0.75, 2);
  }

  function getReferenceCanvasSize(sizeId, aspectRatio) {
    var parsed = parseSizeId(sizeId) || { width: 1, height: 1 };
    var ratio = Number(aspectRatio) || (parsed.width / parsed.height);

    if (ratio > 1.2) {
      return {
        width: Math.max(parsed.width, 36),
        height: Math.max(parsed.height, 24),
      };
    }
    if (ratio < 0.8) {
      return {
        width: Math.max(parsed.width, 24),
        height: Math.max(parsed.height, 36),
      };
    }
    return {
      width: Math.max(parsed.width, 36),
      height: Math.max(parsed.height, 36),
    };
  }

  function getSceneShadow(scene, framed) {
    var fallbackY = framed ? 12 : 28;
    return {
      offsetX: Number(scene && scene.shadowOffsetX) || 0,
      offsetY: Number(scene && scene.shadowOffsetY) || fallbackY,
      blur: Number(scene && scene.shadowBlur) || (framed ? 16 : 40),
      opacity: Number(scene && scene.shadowOpacity) || (framed ? 0.2 : 0.28),
    };
  }

  function getLegacyPieceDimensions(displayRect, sizeId, aspectRatio) {
    var fallbackScale = getSizeScale(sizeId);
    var availableWidth = displayRect.width * fallbackScale;
    var availableHeight = displayRect.height * fallbackScale;
    var fallbackWidth = Math.max(24, availableWidth);
    var fallbackHeight = fallbackWidth / aspectRatio;

    if (fallbackHeight > availableHeight) {
      fallbackHeight = Math.max(24, availableHeight);
      fallbackWidth = fallbackHeight * aspectRatio;
    }

    return {
      width: fallbackWidth,
      height: fallbackHeight,
    };
  }

  function getPieceDimensions(displayRect, scene, sizeId, aspectRatio) {
    var parsed = parseSizeId(sizeId);
    if (parsed && parsed.width > 0 && parsed.height > 0) {
      var wallSize = getSceneWallSize(scene);
      var pixelsPerInch = Math.min(
        displayRect.width / Math.max(1, wallSize.width),
        displayRect.height / Math.max(1, wallSize.height)
      );
      var artScale = getSceneArtScale(scene);
      var basePixelsPerInch = pixelsPerInch * artScale;
      var referenceSize = getReferenceCanvasSize(sizeId, aspectRatio);
      var referenceWidth = referenceSize.width * basePixelsPerInch;
      var referenceHeight = referenceSize.height * basePixelsPerInch;
      var fitScale = Math.min(
        1,
        (displayRect.width * 0.92) / Math.max(1, referenceWidth),
        (displayRect.height * 0.92) / Math.max(1, referenceHeight)
      );
      var width = parsed.width * basePixelsPerInch * fitScale;
      var height = parsed.height * basePixelsPerInch * fitScale;
      var minReadableSide = Math.max(16, Math.min(displayRect.width, displayRect.height) * 0.08);
      var readableScale = Math.min(width, height) > 0
        ? Math.max(1, minReadableSide / Math.min(width, height))
        : 1;
      width *= readableScale;
      height *= readableScale;

      var safetyFitScale = Math.min(
        1,
        (displayRect.width * 0.92) / Math.max(1, width),
        (displayRect.height * 0.92) / Math.max(1, height)
      );

      return {
        width: Math.max(24, width * safetyFitScale),
        height: Math.max(24, height * safetyFitScale),
      };
    }

    return getLegacyPieceDimensions(displayRect, sizeId, aspectRatio);
  }

  function getSceneDefinitions() {
    var assets = window.PrintyhouseKonvaSceneAssets || {};
    return {
      wallA: {
        id: 'wallA',
        backgroundUrl: String(assets.wallA || '').trim(),
        wallRect: { x: 0.24, y: 0.15, width: 0.52, height: 0.38 },
        wallSizeInches: { width: 64, height: 42 },
        artScale: 1.32,
        shadowOffsetX: 8,
        shadowOffsetY: 22,
        shadowBlur: 30,
        shadowOpacity: 0.34,
        backdropTop: '#f5f1ea',
        backdropBottom: '#e7dccd',
        overlay: 'rgba(255,255,255,0.08)',
      },
      wallB: {
        id: 'wallB',
        backgroundUrl: String(assets.wallB || '').trim(),
        wallRect: { x: 0.29, y: 0.13, width: 0.43, height: 0.45 },
        wallSizeInches: { width: 64, height: 44 },
        artScale: 1.4,
        shadowOffsetX: 7,
        shadowOffsetY: 20,
        shadowBlur: 28,
        shadowOpacity: 0.34,
        backdropTop: '#f3ead8',
        backdropBottom: '#dbc8a4',
        overlay: 'rgba(255,248,231,0.06)',
      },
      wallC: {
        id: 'wallC',
        backgroundUrl: String(assets.wallC || '').trim(),
        wallRect: { x: 0.24, y: 0.12, width: 0.42, height: 0.46 },
        wallSizeInches: { width: 64, height: 44 },
        artScale: 1.62,
        shadowOffsetX: -7,
        shadowOffsetY: 20,
        shadowBlur: 28,
        shadowOpacity: 0.34,
        backdropTop: '#f4efe8',
        backdropBottom: '#ded4c8',
        overlay: 'rgba(255,255,255,0.1)',
      },
    };
  }

  function getSceneDefinition(options) {
    var defs = getSceneDefinitions();
    var requestedId = String(options && options.sceneId || '').trim();
    var defaultId = options && options.framed === false ? 'wallA' : 'wallC';
    var scene = defs[requestedId] || defs[defaultId] || defs.wallA || null;
    if (!scene && options && options.sceneBackgroundUrl) {
      return {
        id: requestedId || 'custom',
        backgroundUrl: String(options.sceneBackgroundUrl).trim(),
        wallRect: { x: 0.2, y: 0.12, width: 0.46, height: 0.36 },
        wallSizeInches: { width: 76, height: 50 },
        artScale: 1.55,
        shadowOffsetX: 6,
        shadowOffsetY: 22,
        shadowBlur: 32,
        shadowOpacity: 0.24,
        backdropTop: '#f4ede4',
        backdropBottom: '#e0d1c2',
        overlay: 'rgba(255,255,255,0.08)',
      };
    }
    if (scene && options && options.sceneBackgroundUrl) {
      return Object.assign({}, scene, {
        backgroundUrl: String(options.sceneBackgroundUrl).trim(),
      });
    }
    return scene;
  }

  function getFramePalette(frameColor) {
    var color = String(frameColor || '').toLowerCase();
    if (color === 'white') {
      return {
        outer: '#f8f6f0',
        edge: '#d6cec0',
        innerEdge: 'rgba(124,111,95,0.28)',
        shadow: '#7b7065',
        highlight: 'rgba(255,255,255,0.76)',
        lowlight: 'rgba(110,97,82,0.14)',
        edgeAccents: false,
      };
    }
    if (color === 'espresso') {
      return {
        outer: '#4f3323',
        edge: '#2b1b12',
        innerEdge: 'rgba(255,240,226,0.18)',
        shadow: '#3e2516',
        highlight: 'rgba(255,244,233,0.14)',
        lowlight: 'rgba(25,16,10,0.22)',
        edgeAccents: true,
      };
    }
    return {
      outer: '#161514',
      edge: '#34312e',
      innerEdge: 'rgba(255,255,255,0.18)',
      shadow: '#090807',
      highlight: 'rgba(255,255,255,0.1)',
      lowlight: 'rgba(0,0,0,0.32)',
      edgeAccents: true,
    };
  }

  var imagePromiseCache = Object.create(null);

  function getCoverCrop(image, targetWidth, targetHeight) {
    var sourceWidth = Number(image && image.width) || 1;
    var sourceHeight = Number(image && image.height) || 1;
    var sourceRatio = sourceWidth / sourceHeight;
    var targetRatio = targetWidth / targetHeight;

    if (sourceRatio > targetRatio) {
      var cropWidth = sourceHeight * targetRatio;
      return {
        x: (sourceWidth - cropWidth) / 2,
        y: 0,
        width: cropWidth,
        height: sourceHeight,
      };
    }

    var cropHeight = sourceWidth / targetRatio;
    return {
      x: 0,
      y: (sourceHeight - cropHeight) / 2,
      width: sourceWidth,
      height: cropHeight,
    };
  }

  function loadImage(url) {
    var key = String(url || '').trim();
    if (!key) return Promise.reject(new Error('Image URL is required.'));
    if (imagePromiseCache[key]) return imagePromiseCache[key];

    imagePromiseCache[key] = new Promise(function (resolve, reject) {
      var img = new window.Image();
      if (!/^data:/i.test(key)) {
        img.crossOrigin = 'anonymous';
      }
      img.onload = function () {
        resolve(img);
      };
      img.onerror = function () {
        delete imagePromiseCache[key];
        reject(new Error('Could not load preview image for Konva mockup.'));
      };
      img.src = key;
    });
    return imagePromiseCache[key];
  }

  var konvaLoadPromise = null;

  function ensureKonvaLoaded() {
    if (window.Konva) return Promise.resolve(window.Konva);
    if (konvaLoadPromise) return konvaLoadPromise;

    konvaLoadPromise = new Promise(function (resolve, reject) {
      var existing = document.querySelector('script[data-konva-library="printyhouse"]');
      if (existing) {
        existing.addEventListener('load', function () {
          if (window.Konva) resolve(window.Konva);
          else reject(new Error('Konva loaded without exposing window.Konva.'));
        }, { once: true });
        existing.addEventListener('error', function () {
          reject(new Error('Konva failed to load.'));
        }, { once: true });
        return;
      }

      var script = document.createElement('script');
      script.src = window.PrintyhouseKonvaAssetUrl || '';
      script.defer = true;
      script.dataset.konvaLibrary = 'printyhouse';
      script.onload = function () {
        if (window.Konva) resolve(window.Konva);
        else reject(new Error('Konva loaded without exposing window.Konva.'));
      };
      script.onerror = function () {
        reject(new Error('Konva failed to load.'));
      };
      document.head.appendChild(script);
    });

    return konvaLoadPromise;
  }

  function getSceneImageUrl(options) {
    var scene = getSceneDefinition(options);
    return scene ? String(scene.backgroundUrl || '').trim() : '';
  }

  function preload(options) {
    var state = Object.assign({}, options || {});
    var sceneImageUrl = getSceneImageUrl(state);
    return Promise.all([
      ensureKonvaLoaded().catch(function () { return null; }),
      state.imageUrl ? loadImage(state.imageUrl).catch(function () { return null; }) : Promise.resolve(null),
      sceneImageUrl ? loadImage(sceneImageUrl).catch(function () { return null; }) : Promise.resolve(null),
    ]);
  }

  function getPreparingBackdropStyle(options) {
    var state = Object.assign({}, options || {});
    var scene = getSceneDefinition(state);
    var sceneImageUrl = scene ? String(scene.backgroundUrl || '').trim() : '';
    var targetWidth = Math.max(1, Math.round(Number(state.targetWidth) || Number(state.width) || 1));
    var targetHeight = Math.max(1, Math.round(Number(state.targetHeight) || Number(state.height) || 1));
    if (!sceneImageUrl || !targetWidth || !targetHeight) return Promise.resolve(null);

    return loadImage(sceneImageUrl).then(function (backgroundImage) {
      var crop = getFocusedCoverCrop(backgroundImage, targetWidth, targetHeight, scene && scene.wallRect);
      var scaleX = targetWidth / Math.max(1, crop.width);
      var scaleY = targetHeight / Math.max(1, crop.height);
      var positionX = -crop.x * scaleX;
      var positionY = -crop.y * scaleY;
      var sizeWidth = (Number(backgroundImage.width) || 1) * scaleX;
      var sizeHeight = (Number(backgroundImage.height) || 1) * scaleY;

      return {
        imageUrl: sceneImageUrl,
        backgroundPosition: positionX.toFixed(2) + 'px ' + positionY.toFixed(2) + 'px',
        backgroundSize: sizeWidth.toFixed(2) + 'px ' + sizeHeight.toFixed(2) + 'px',
      };
    });
  }

  function drawFallbackBackdrop(layer, width, height) {
    layer.add(new window.Konva.Rect({
      x: 0,
      y: 0,
      width: width,
      height: height,
      fillLinearGradientStartPoint: { x: 0, y: 0 },
      fillLinearGradientEndPoint: { x: 0, y: height },
      fillLinearGradientColorStops: [0, '#f7f0e7', 0.46, '#eadfce', 1, '#d9c0a8'],
      listening: false,
    }));

    layer.add(new window.Konva.Circle({
      x: width * 0.17,
      y: height * 0.16,
      radius: Math.max(width, height) * 0.14,
      fill: 'rgba(255,255,255,0.28)',
      listening: false,
    }));

    layer.add(new window.Konva.Circle({
      x: width * 0.84,
      y: height * 0.22,
      radius: Math.max(width, height) * 0.18,
      fill: 'rgba(217,195,170,0.22)',
      listening: false,
    }));

    layer.add(new window.Konva.Rect({
      x: 0,
      y: height * 0.72,
      width: width,
      height: height * 0.28,
      fillLinearGradientStartPoint: { x: 0, y: height * 0.72 },
      fillLinearGradientEndPoint: { x: 0, y: height },
      fillLinearGradientColorStops: [0, 'rgba(255,255,255,0.08)', 1, 'rgba(132,95,63,0.28)'],
      listening: false,
    }));

    layer.add(new window.Konva.Line({
      points: [0, height * 0.72, width, height * 0.72],
      stroke: 'rgba(121,88,60,0.22)',
      strokeWidth: 1.5,
      listening: false,
    }));
  }

  function getFocusedCoverCrop(image, targetWidth, targetHeight, wallRect) {
    var sourceWidth = Number(image && image.width) || 1;
    var sourceHeight = Number(image && image.height) || 1;
    var sourceRatio = sourceWidth / sourceHeight;
    var targetRatio = targetWidth / targetHeight;
    var crop = getCoverCrop(image, targetWidth, targetHeight);
    if (!wallRect) return crop;

    var wallLeft = clamp(Number(wallRect.x) || 0, 0, 1) * sourceWidth;
    var wallTop = clamp(Number(wallRect.y) || 0, 0, 1) * sourceHeight;
    var wallWidth = clamp(Number(wallRect.width) || 0.4, 0.05, 1) * sourceWidth;
    var wallHeight = clamp(Number(wallRect.height) || 0.35, 0.05, 1) * sourceHeight;
    var wallRight = wallLeft + wallWidth;
    var wallBottom = wallTop + wallHeight;
    var padX = sourceWidth * 0.05;
    var padY = sourceHeight * 0.06;

    if (sourceRatio > targetRatio) {
      var cropWidth = sourceHeight * targetRatio;
      var focusX = wallLeft + (wallWidth / 2);
      var minCropX = Math.max(0, wallRight + padX - cropWidth);
      var maxCropX = Math.min(sourceWidth - cropWidth, wallLeft - padX);
      var cropX = clamp(focusX - (cropWidth / 2), 0, sourceWidth - cropWidth);
      if (minCropX <= maxCropX) cropX = clamp(cropX, minCropX, maxCropX);
      return {
        x: cropX,
        y: 0,
        width: cropWidth,
        height: sourceHeight,
      };
    }

    var cropHeight = sourceWidth / targetRatio;
    var focusY = wallTop + (wallHeight / 2);
    var minCropY = Math.max(0, wallBottom + padY - cropHeight);
    var maxCropY = Math.min(sourceHeight - cropHeight, wallTop - padY);
    var cropY = clamp(focusY - (cropHeight / 2), 0, sourceHeight - cropHeight);
    if (minCropY <= maxCropY) cropY = clamp(cropY, minCropY, maxCropY);
    return {
      x: 0,
      y: cropY,
      width: sourceWidth,
      height: cropHeight,
    };
  }

  function getSceneDisplayRect(backgroundImage, crop, stageWidth, stageHeight, scene) {
    var wallRect = scene && scene.wallRect;
    if (!backgroundImage || !crop || !wallRect) return null;

    var sourceWidth = Number(backgroundImage && backgroundImage.width) || 1;
    var sourceHeight = Number(backgroundImage && backgroundImage.height) || 1;
    var wallLeft = clamp(Number(wallRect.x) || 0, 0, 1) * sourceWidth;
    var wallTop = clamp(Number(wallRect.y) || 0, 0, 1) * sourceHeight;
    var wallWidth = clamp(Number(wallRect.width) || 0.4, 0.05, 1) * sourceWidth;
    var wallHeight = clamp(Number(wallRect.height) || 0.35, 0.05, 1) * sourceHeight;
    var scaleX = stageWidth / crop.width;
    var scaleY = stageHeight / crop.height;

    return {
      x: clamp((wallLeft - crop.x) * scaleX, 0, stageWidth),
      y: clamp((wallTop - crop.y) * scaleY, 0, stageHeight),
      width: clamp(wallWidth * scaleX, 10, stageWidth),
      height: clamp(wallHeight * scaleY, 10, stageHeight),
    };
  }

  function getFallbackDisplayRect(width, height) {
    return {
      x: width * 0.26,
      y: height * 0.14,
      width: width * 0.48,
      height: height * 0.5,
    };
  }

  function drawPhotoBackdrop(layer, width, height, backgroundImage, scene) {
    var crop = getFocusedCoverCrop(backgroundImage, width, height, scene && scene.wallRect);

    layer.add(new window.Konva.Rect({
      x: 0,
      y: 0,
      width: width,
      height: height,
      fillLinearGradientStartPoint: { x: 0, y: 0 },
      fillLinearGradientEndPoint: { x: 0, y: height },
      fillLinearGradientColorStops: [
        0,
        (scene && scene.backdropTop) || '#f5efe7',
        1,
        (scene && scene.backdropBottom) || '#dfd2c3',
      ],
      listening: false,
    }));

    layer.add(new window.Konva.Image({
      image: backgroundImage,
      x: 0,
      y: 0,
      width: width,
      height: height,
      crop: crop,
      perfectDrawEnabled: false,
      listening: false,
    }));

    layer.add(new window.Konva.Rect({
      x: 0,
      y: 0,
      width: width,
      height: height,
      fill: (scene && scene.overlay) || 'rgba(248,239,228,0.16)',
      listening: false,
    }));

    layer.add(new window.Konva.Rect({
      x: 0,
      y: 0,
      width: width,
      height: height,
      fillLinearGradientStartPoint: { x: 0, y: 0 },
      fillLinearGradientEndPoint: { x: width, y: height },
      fillLinearGradientColorStops: [0, 'rgba(255,255,255,0.24)', 0.45, 'rgba(255,255,255,0)', 1, 'rgba(74,45,18,0.12)'],
      listening: false,
    }));

    return {
      displayRect: getSceneDisplayRect(backgroundImage, crop, width, height, scene),
    };
  }

  function drawScene(stage, layer, sourceImage, backgroundImage, options) {
    layer.destroyChildren();

    var width = stage.width();
    var height = stage.height();
    var hasPhotoBackdrop = Boolean(backgroundImage);
    var scene = getSceneDefinition(options);
    var framed = Boolean(options && options.framed);
    var framePalette = getFramePalette(options && options.frameColor);
    var aspectRatio = getAspectRatioValue(options && options.aspectRatio, options && options.sizeId);
    var canvasDepth = Math.round(clamp(Math.min(width, height) * 0.015, 4, 8));
    var sideDepthX = Math.max(2, Math.round(canvasDepth * 0.56));
    var sideDepthY = Math.max(1, Math.round(canvasDepth * 0.3));
    var backdropMetrics = hasPhotoBackdrop
      ? drawPhotoBackdrop(layer, width, height, backgroundImage, scene)
      : (drawFallbackBackdrop(layer, width, height), { displayRect: getFallbackDisplayRect(width, height) });
    var displayRect = backdropMetrics && backdropMetrics.displayRect
      ? backdropMetrics.displayRect
      : getFallbackDisplayRect(width, height);
    var pieceSize = getPieceDimensions(displayRect, scene, options && options.sizeId, aspectRatio);
    var pieceShortSide = Math.min(pieceSize.width, pieceSize.height);
    var frameWidth = framed ? Math.round(clamp(pieceShortSide * 0.055, 3, 9)) : 0;
    var matWidth = 0;
    var edgeInset = framed ? (frameWidth + matWidth) * 2 : 0;
    var artWidth = pieceSize.width;
    var artHeight = pieceSize.height;
    var framedFitScale = Math.min(
      1,
      (displayRect.width * 0.92) / Math.max(1, artWidth + edgeInset),
      (displayRect.height * 0.92) / Math.max(1, artHeight + edgeInset)
    );

    artWidth *= framedFitScale;
    artHeight *= framedFitScale;

    var totalWidth = artWidth + edgeInset;
    var totalHeight = artHeight + edgeInset;
    var displayCenterX = displayRect.x + (displayRect.width / 2);
    var displayCenterY = displayRect.y + (displayRect.height / 2);
    var originX = Math.round(displayCenterX - (totalWidth / 2));
    var originY = Math.round(displayCenterY - (totalHeight / 2));
    var artX = originX + (framed ? frameWidth + matWidth : 0);
    var artY = originY + (framed ? frameWidth + matWidth : 0);
    var sceneShadow = getSceneShadow(scene, framed);
    var contactShadowHeight = Math.round(clamp(Math.min(totalWidth, totalHeight) * 0.022, 2, 5));
    var castShadowX = originX + Math.round(sceneShadow.offsetX * (framed ? 0.24 : 0.34));
    var castShadowY = originY + Math.round(sceneShadow.offsetY * (framed ? 0.28 : 0.36));

    layer.add(new window.Konva.Rect({
      x: castShadowX,
      y: castShadowY,
      width: totalWidth,
      height: totalHeight,
      fill: framed ? 'rgba(44,32,24,0.06)' : 'rgba(58,40,28,0.075)',
      shadowColor: framed ? framePalette.shadow : '#463123',
      shadowBlur: framed ? 12 : 20,
      shadowOpacity: framed ? 0.18 : 0.38,
      shadowOffsetX: 0,
      shadowOffsetY: 0,
      cornerRadius: 0,
      listening: false,
    }));

    layer.add(new window.Konva.Rect({
      x: originX + (framed ? 3 : sideDepthX),
      y: originY + (framed ? 5 : sideDepthY),
      width: totalWidth,
      height: totalHeight,
      fill: framed ? 'rgba(42,32,24,0.13)' : 'rgba(70,48,34,0.18)',
      shadowColor: framed ? framePalette.shadow : '#604936',
      shadowBlur: sceneShadow.blur,
      shadowOpacity: sceneShadow.opacity,
      shadowOffsetX: sceneShadow.offsetX,
      shadowOffsetY: sceneShadow.offsetY,
      cornerRadius: 0,
      listening: false,
    }));

    layer.add(new window.Konva.Rect({
      x: originX + (framed ? 2 : Math.round(sideDepthX * 0.5)),
      y: originY + totalHeight + (framed ? 1 : Math.round(sideDepthY * 0.6)),
      width: totalWidth + (framed ? 0 : sideDepthX),
      height: contactShadowHeight,
      fill: framed ? 'rgba(46,34,25,0.08)' : 'rgba(64,44,30,0.1)',
      shadowColor: framed ? framePalette.shadow : '#4c3525',
      shadowBlur: framed ? 8 : 14,
      shadowOpacity: framed ? 0.16 : 0.34,
      shadowOffsetX: sceneShadow.offsetX * 0.2,
      shadowOffsetY: framed ? 2 : 3,
      cornerRadius: contactShadowHeight / 2,
      listening: false,
    }));

    if (framed) {
      layer.add(new window.Konva.Rect({
        x: originX,
        y: originY,
        width: totalWidth,
        height: totalHeight,
        fill: framePalette.outer,
        cornerRadius: 0,
        listening: false,
      }));

      if (framePalette.edgeAccents !== false) {
        layer.add(new window.Konva.Line({
          points: [originX + 2, originY + totalHeight - 2, originX + 2, originY + 2, originX + totalWidth - 2, originY + 2],
          stroke: framePalette.highlight,
          strokeWidth: 1,
          listening: false,
        }));

        layer.add(new window.Konva.Line({
          points: [originX + 2, originY + totalHeight - 2, originX + totalWidth - 2, originY + totalHeight - 2, originX + totalWidth - 2, originY + 2],
          stroke: framePalette.lowlight,
          strokeWidth: 1,
          listening: false,
        }));

        layer.add(new window.Konva.Rect({
          x: originX + 1.5,
          y: originY + 1.5,
          width: totalWidth - 3,
          height: totalHeight - 3,
          stroke: framePalette.edge,
          strokeWidth: 1,
          cornerRadius: 0,
          listening: false,
        }));
      }

      layer.add(new window.Konva.Rect({
        x: artX - 0.5,
        y: artY - 0.5,
        width: artWidth + 1,
        height: artHeight + 1,
        stroke: framePalette.innerEdge,
        strokeWidth: 1,
        cornerRadius: 0,
        listening: false,
      }));
    } else {
      layer.add(new window.Konva.Line({
        points: [artX + artWidth, artY, artX + artWidth + sideDepthX, artY + sideDepthY, artX + artWidth + sideDepthX, artY + artHeight + sideDepthY, artX + artWidth, artY + artHeight],
        closed: true,
        fill: '#e5dfd7',
        opacity: 0.91,
        listening: false,
      }));

      layer.add(new window.Konva.Line({
        points: [artX, artY + artHeight, artX + artWidth, artY + artHeight, artX + artWidth + sideDepthX, artY + artHeight + sideDepthY, artX + sideDepthX, artY + artHeight + sideDepthY],
        closed: true,
        fill: '#d8d0c6',
        opacity: 0.87,
        listening: false,
      }));

      layer.add(new window.Konva.Line({
        points: [artX, artY, artX + artWidth, artY],
        stroke: 'rgba(255,255,255,0.58)',
        strokeWidth: 1.25,
        listening: false,
      }));
    }

    var crop = getCoverCrop(sourceImage, artWidth, artHeight);
    layer.add(new window.Konva.Image({
      image: sourceImage,
      x: artX,
      y: artY,
      width: artWidth,
      height: artHeight,
      crop: crop,
      perfectDrawEnabled: false,
      listening: false,
    }));

    layer.add(new window.Konva.Rect({
      x: artX,
      y: artY,
      width: artWidth,
      height: artHeight,
      stroke: framed ? 'rgba(97,70,48,0.22)' : 'rgba(212,204,194,0.6)',
      strokeWidth: 1.2,
      listening: false,
    }));

    layer.add(new window.Konva.Rect({
      x: artX,
      y: artY,
      width: artWidth,
      height: artHeight,
      fillLinearGradientStartPoint: { x: artX, y: artY },
      fillLinearGradientEndPoint: { x: artX, y: artY + artHeight },
      fillLinearGradientColorStops: [0, 'rgba(255,255,255,0.12)', 0.4, 'rgba(255,255,255,0)', 1, 'rgba(55,35,19,0.05)'],
      listening: false,
    }));

    layer.batchDraw();
  }

  function createController(config) {
    var wrapper = config && config.wrapper;
    var imageEl = config && config.imageEl;
    if (!wrapper) {
      throw new Error('A wrapper element is required for Konva mockups.');
    }

    var container = wrapper.querySelector('.ai-konva-mockup-layer');
    if (!container) {
      container = document.createElement('div');
      container.className = 'ai-konva-mockup-layer';
      wrapper.appendChild(container);
    }

    var stage = null;
    var layer = null;
    var currentState = null;
    var renderVersion = 0;
    var resizeBound = null;
    var resizeObserver = null;

    function ensureStage() {
      if (!window.Konva) return;
      var bounds = wrapper.getBoundingClientRect();
      var width = Math.max(1, Math.round(bounds.width));
      var height = Math.max(1, Math.round(bounds.height));

      if (!stage) {
        stage = new window.Konva.Stage({
          container: container,
          width: width,
          height: height,
        });
        layer = new window.Konva.Layer();
        stage.add(layer);
        return;
      }

      if (stage.width() !== width || stage.height() !== height) {
        stage.size({ width: width, height: height });
      }
    }

    function setKonvaActive(isActive) {
      container.style.display = isActive ? 'block' : 'none';
      wrapper.classList.toggle('has-konva-mockup', Boolean(isActive));
      if (isActive) wrapper.classList.remove('is-konva-preparing');
      if (!imageEl) return;
      imageEl.classList.toggle('is-konva-hidden', Boolean(isActive));
      if (isActive) imageEl.setAttribute('aria-hidden', 'true');
      else imageEl.removeAttribute('aria-hidden');
    }

    function rerenderCurrentState() {
      if (!currentState) return;
      render(currentState).catch(function () {});
    }

    if (typeof window.ResizeObserver === 'function') {
      resizeObserver = new window.ResizeObserver(function () {
        if (!currentState) return;
        if (window.requestAnimationFrame) window.requestAnimationFrame(rerenderCurrentState);
        else rerenderCurrentState();
      });
      resizeObserver.observe(wrapper);
    } else {
      resizeBound = rerenderCurrentState;
      window.addEventListener('resize', resizeBound);
    }

    async function render(nextState) {
      currentState = Object.assign({}, nextState || {});
      if (!currentState.imageUrl) {
        clear();
        return;
      }

      renderVersion += 1;
      var requestVersion = renderVersion;
      await ensureKonvaLoaded();
      if (requestVersion !== renderVersion) return;

      ensureStage();
      var sceneImageUrl = getSceneImageUrl(currentState);
      var images = await Promise.all([
        loadImage(currentState.imageUrl),
        sceneImageUrl ? loadImage(sceneImageUrl).catch(function () { return null; }) : Promise.resolve(null),
      ]);
      if (requestVersion !== renderVersion) return;

      ensureStage();
      drawScene(stage, layer, images[0], images[1], currentState);
      setKonvaActive(true);
    }

    function clear() {
      renderVersion += 1;
      currentState = null;
      if (layer) {
        layer.destroyChildren();
        layer.batchDraw();
      }
      setKonvaActive(false);
    }

    function destroy() {
      clear();
      if (resizeObserver) resizeObserver.disconnect();
      if (resizeBound) window.removeEventListener('resize', resizeBound);
      if (stage) stage.destroy();
      stage = null;
      layer = null;
      if (container && container.parentNode) container.parentNode.removeChild(container);
    }

    return {
      render: render,
      clear: clear,
      destroy: destroy,
    };
  }

  window.PrintyhouseKonvaMockups = {
    ensureKonvaLoaded: ensureKonvaLoaded,
    preload: preload,
    getPreparingBackdropStyle: getPreparingBackdropStyle,
    createController: createController,
  };
})();
